import type { ContentStatus } from "@a7y/types";

/**
 * Blog CMS editor constants (A7Y-2068). Kept free of React so `utils.ts` and the
 * unit tests can import them without pulling in the component tree.
 */

// --- SEO description length guidance (meta description best practice) ---
export const SEO_DESC_MIN = 120;
export const SEO_DESC_MAX = 158;

// --- Image upload guardrails (mirror the API's ALLOWED_IMAGE_MIME / 5 MB cap) ---
export const ALLOWED_IMAGE_MIME = new Set<string>([
  "image/png",
  "image/jpeg",
  "image/webp",
  "image/svg+xml",
  "image/gif",
]);

export const MAX_IMAGE_BYTES = 5 * 1024 * 1024; // 5 MB

// --- Autosave / work-loss prevention ---
export const AUTOSAVE_DELAY_MS = 1500;
export const DRAFT_STORAGE_PREFIX = "a7y-content-blog-draft:";
/** A7Y-4470: the docs editor's own local-mirror prefix — kept distinct from
 *  the blog prefix so a stray draft never resolves against the wrong section. */
export const DOCS_DRAFT_STORAGE_PREFIX = "a7y-content-docs-draft:";

// --- Staging preview (the /blog/preview/<id> route only serves draft/scheduled) ---
export const STAGING_BASE_URL = "https://www-staging.apptonomy.ai";
export const PROD_BASE_URL = "https://www.apptonomy.ai";

// --- Status filter + badge palette ---
export const STATUS_FILTER_OPTIONS: { value: string; label: string }[] = [
  { value: "all", label: "All statuses" },
  { value: "draft", label: "Draft" },
  { value: "scheduled", label: "Scheduled" },
  { value: "published", label: "Published" },
  { value: "archived", label: "Archived" },
];

// Catalyst's `green` is remapped to `--color-sev-low`, which is a desaturated
// blue-grey (oklch hue 260, chroma 0.03) — the severity-low tint, not a green.
// `emerald` is one of the palette keys that still carries literal Tailwind
// classes, so it renders as an actual green.
export const STATUS_BADGE_COLOR: Record<ContentStatus, string> = {
  draft: "zinc",
  scheduled: "amber",
  published: "emerald",
  archived: "zinc",
};

export const REVISION_REASON_COLOR: Record<string, string> = {
  publish: "green",
  unpublish: "amber",
  restore: "blue",
  archive: "red",
};
